import styled from '@emotion/styled'

const Paragraph = styled.p`
  /* font-family: ${({theme}) => theme.typography.paragraph.fontFamily};
  color: ${({theme}) => theme.typography.paragraph.color};
  line-height: 1.75rem;
  opacity: 0.6;
  transition: color 0.2s; */
`

export default Paragraph
